let auth = {
  login: {
    invalid: 'E-mail or password invalid',
    error: 'Unable to login'
  }
};

export default auth;
